function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _class2, _class3, _descriptor, _descriptor2, _descriptor3, _temp;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable no-console */

/* eslint-disable max-len */

/* eslint no-mixed-spaces-and-tabs: "off" */
import axios from 'axios';
import gsap from 'gsap';
import { bind, Component, el, emitEvent, reactive, register, watch } from 'ovee.js';
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';
import Cookies from 'js-cookie';
import { sha256 } from 'js-sha256';
import { braze } from '@/tools/braze';

var filter = function filter(list, selector) {
  list = _toConsumableArray(list);
  return list.filter(function (item) {
    return item.matches(selector);
  });
};

var each = function each(list) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  list.forEach(function (item) {
    return callback(item);
  });
};

var is = function is(element, selector) {
  if (selector.nodeType) {
    return element === selector;
  }

  var elements = typeof selector === 'string' ? document.querySelectorAll(selector) : selector;
  var elementsLength = elements.length;

  while (elementsLength--) {
    if (elements[elementsLength] === element) {
      return true;
    }
  }

  return false;
};

var DEFAULT_FORMS_VERSION = 2;

var _class = (_dec = register('form-base'), _dec2 = el('.form__ajax-message', {
  list: true
}), _dec3 = el('[data-form-step-label]', {
  list: true
}), _dec4 = reactive(), _dec5 = bind('blur input focus', 'input, select, textarea'), _dec6 = bind('click', '.custom-checkbox'), _dec7 = bind('click', '[data-form-next]'), _dec8 = bind('click', '[data-form-previous]'), _dec9 = bind('click', window), _dec10 = bind('click', '.phone-codes__current'), _dec11 = bind('change', '[name="phone_code"'), _dec12 = bind('open'), _dec13 = bind('submit'), _dec14 = watch('currentStep'), _dec15 = bind('modal-close', window), _dec(_class2 = (_class3 = (_temp = /*#__PURE__*/function (_Component) {
  _inherits(_class3, _Component);

  var _super = _createSuper(_class3);

  function _class3() {
    var _this;

    _classCallCheck(this, _class3);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_assertThisInitialized(_this), "ajaxMessage", _descriptor, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "version", DEFAULT_FORMS_VERSION);

    _initializerDefineProperty(_assertThisInitialized(_this), "stepsLabels", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "currentStep", _descriptor3, _assertThisInitialized(_this));

    return _this;
  }

  _createClass(_class3, [{
    key: "init",
    value: function init() {
      var _ref, _this$$app$getConfig$;

      this.isHoldingForm = this.$element.dataset.formBase === 'holding-page';
      this.isSignupEventForm = this.$element.classList.contains('form--event-signup');
      this.isEnquireForm = this.$element.dataset.formBase === 'enquire';
      this.isVipTablesForm = this.$element.dataset.formBase === 'vip-tables';
      this.version = parseInt((_ref = (_this$$app$getConfig$ = this.$app.getConfig().formsVersion) !== null && _this$$app$getConfig$ !== void 0 ? _this$$app$getConfig$ : this.$element.dataset.formVersion) !== null && _ref !== void 0 ? _ref : DEFAULT_FORMS_VERSION, 10);
      this.initSteps();
    }
  }, {
    key: "inputBlurHandler",
    value: function inputBlurHandler(_ref2) {
      var target = _ref2.target;
      var parentNode = target.parentNode;
      target.classList.remove('has-error');

      if (parentNode.classList.contains('custom-select')) {
        parentNode.classList.remove('has-error');
      }
    }
  }, {
    key: "customCheckboxClickHandler",
    value: function customCheckboxClickHandler(_ref3) {
      var target = _ref3.target;
      var checkboxInput = target.querySelector('input[type="checkbox"]');

      if (checkboxInput) {
        checkboxInput.classList.remove('has-error');
      }
    }
  }, {
    key: "nextStepHandler",
    value: function nextStepHandler(e) {
      e.preventDefault();
      this.nextStep();
    }
  }, {
    key: "previousStepHandler",
    value: function previousStepHandler(e) {
      e.preventDefault();
      this.previousStep();
    }
  }, {
    key: "phoneCodeHide",
    value: function phoneCodeHide(_ref4) {
      var target = _ref4.target;

      if (!target.matches('.phone-codes__current')) {
        var list = this.$element.querySelector('.phone-codes__list');
        if (list) list.classList.remove('is-active');
      }
    }
  }, {
    key: "phoneCodeCurrent",
    value: function phoneCodeCurrent() {
      var list = this.$element.querySelector('.phone-codes__list');
      if (list) list.classList.toggle('is-active');
    }
  }, {
    key: "phoneCodeChange",
    value: function phoneCodeChange(_ref5) {
      var target = _ref5.target;
      var list = this.$element.querySelector('.phone-codes__list');
      var current = this.$element.querySelector('.phone-codes__current-value');
      var inputValue = target.value;
      if (list) list.classList.remove('is-active');
      if (current) current.innerHTML = inputValue;
    }
  }, {
    key: "openHandler",
    value: function openHandler() {
      if (this.$element.dataset.formNoReset === undefined) {
        var inputs = this.$element.querySelectorAll('input[type=text], input[type=tel], input[type=number], select, input[type=email], textarea');
        var checkboxes = this.$element.querySelectorAll('input[type=checkbox]');
        each(inputs, function (input) {
          input.value = '';
          emitEvent(input, 'change');
        });
        each(checkboxes, function (checkbox) {
          checkbox.checked = false;
          emitEvent(checkbox, 'change');
        });
      }

      this.defaultStep();
    }
  }, {
    key: "submitHandler",
    value: function submitHandler(e) {
      e.preventDefault();

      if (this.isHoldingForm || this.isSignupEventForm || this.isEnquireForm || this.isVipTablesForm) {
        this.validateForm();
      } else {
        this.submitAction();
      }
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var emailValid = true;
      var phoneValid = true;
      var consentValid = true;
      var firstNameValid = true;
      var lastNameValid = true; // Validate email

      var emailInput = this.$element.querySelector('input[name="email"]');
      var emailValue = emailInput.value;
      var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailPattern.test(emailValue)) {
        emailInput.classList.add('has-error');
        emailValid = false;
      } else {
        emailValid = true;
      } // Validate phone


      if (!this.isVipTablesForm) {
        var phoneInput = this.isSignupEventForm || this.isEnquireForm ? this.$element.querySelector('input[name="phone"]') : this.$element.querySelector('[data-phone-input]');
        var iti = intlTelInput.getInstance(phoneInput);

        if (iti && !iti.isValidNumber()) {
          phoneInput.classList.add('has-error');
          phoneValid = false;
        } else {
          phoneValid = true;
        }
      } // Validate consent


      var consentInput = this.$element.querySelector('input[name="consent"]');
      var consentValue = consentInput.checked;

      if (!consentValue) {
        consentInput.classList.add('has-error');
        consentValid = false;
      } else {
        consentValid = true;
      } // Validate First Name


      var firstNameInput = this.isEnquireForm || this.isVipTablesForm ? this.$element.querySelector('input[name="first-name"]') : undefined;
      var firstNameValue = firstNameInput ? firstNameInput.value.trim() : undefined;

      if (firstNameValue === '') {
        firstNameInput.classList.add('has-error');
        firstNameValid = false;
      } else {
        firstNameValid = true;
      } // Validate Last Name


      var lastNameInput = this.isEnquireForm || this.isVipTablesForm ? this.$element.querySelector('input[name="last-name"]') : undefined;
      var lastNameValue = lastNameInput ? lastNameInput.value.trim() : undefined;

      if (lastNameValue === '') {
        lastNameInput.classList.add('has-error');
        lastNameValid = false;
      } else {
        lastNameValid = true;
      }

      if (emailValid && consentValid && firstNameValid && lastNameValid) {
        this.submitAction();
      }
    }
  }, {
    key: "submitAction",
    value: function submitAction() {
      var _this2 = this;

      if (this.isLastStep()) {
        this.enableLoading();
        this.hideAjaxMessage();
        this.removeErrors();
        this.submit().then(function () {
          _this2.disableLoading();

          if (window.grecaptcha) {
            grecaptcha.reset();
          }
        });
      } else {
        this.nextStep();
      }
    }
  }, {
    key: "hideAjaxMessage",
    value: function hideAjaxMessage() {
      each(this.ajaxMessage, function (msg) {
        return msg.style.display = 'none';
      });
    }
  }, {
    key: "removeErrors",
    value: function removeErrors() {
      var inputs = this.$element.querySelectorAll('input, select, textarea, select, .custom-select');
      this.$element.classList.remove('has-error');
      each(inputs, function (input) {
        input.classList.remove('has-error');
        emitEvent(input, 'blur');
      });
    }
  }, {
    key: "showErrorMsg",
    value: function showErrorMsg() {
      var errorMsg = filter(this.ajaxMessage, '.has-error');
      this.$element.classList.add('has-error');

      if (errorMsg.length > 0) {
        gsap.to(errorMsg, {
          opacity: 1,
          duration: 0.4,
          onStart: function onStart() {
            each(errorMsg, function (msg) {
              return msg.style.display = 'block';
            });
          }
        });
      }
    }
  }, {
    key: "showSuccessMsg",
    value: function showSuccessMsg() {
      var successMsg = filter(this.ajaxMessage, '.is-success');
      this.$element.classList.add('form--success');

      if (successMsg.length > 0) {
        gsap.to(successMsg, {
          opacity: 1,
          duration: 0.4,
          onStart: function onStart() {
            each(successMsg, function (msg) {
              return msg.style.display = 'block';
            });
          }
        });
      }
    }
  }, {
    key: "endpointUrl",
    value: function endpointUrl() {
      if (this.version === 1) {
        return "".concat(ajaxurl, "?action=form_").concat(this.action);
      }

      var baseUrl = document.querySelector('link[rel="https://api.w.org/"]').href;
      return "".concat(baseUrl, "owd-forms/v2/forms/").concat(this.action, "/submit");
    }
  }, {
    key: "endpointHeaders",
    value: function endpointHeaders() {
      return {};
    }
  }, {
    key: "filterData",
    value: function filterData(data) {
      return data;
    }
  }, {
    key: "getErrorsFromResponse",
    value: function getErrorsFromResponse(response) {
      var _response$data, _response$data$data;

      if (this.version === 1) {
        return (response === null || response === void 0 ? void 0 : response.errors) || [];
      } // FIXME: remove nested data object


      return (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$data = _response$data.data) === null || _response$data$data === void 0 ? void 0 : _response$data$data.errors) || {};
    }
  }, {
    key: "checkResponse",
    value: function checkResponse(response, status) {
      if (this.version === 1) {
        return ['200', '201', 200, 201].includes(status) && !!response.result;
      }

      if (status === 403 && (response === null || response === void 0 ? void 0 : response.code) === 'rest_cookie_invalid_nonce') {
        document.location.reload();
      }

      return [200, 201, '200', '201'].includes(status);
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this3 = this;

      var formData = new FormData(this.$element);
      var processedFormData = new FormData(); // Process all form fields

      var ageValues = [];
      var eventsValues = []; // First, collect all values
      // eslint-disable-next-line no-restricted-syntax

      var _iterator = _createForOfIteratorHelper(formData.entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (key === 'age') {
            ageValues.push(value);
          } else if (key === 'events') {
            eventsValues.push(value);
          } else {
            processedFormData.append(key, value);
          }
        } // Process age values

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (ageValues.length > 0) {
        var ageString = ageValues.join(', ');
        processedFormData.append('age', ageString);
      } // Process events values


      if (eventsValues.length > 0) {
        var eventsString = eventsValues.join(', ');
        processedFormData.append('events', eventsString);
      }

      var ajaxParams = {
        url: this.endpointUrl(),
        method: 'POST',
        headers: this.endpointHeaders(),
        data: new URLSearchParams(processedFormData).toString() // URLSearchParams -> IE: Not supported

      };

      if (this.isMultiPart) {
        ajaxParams.data = processedFormData;
      }

      ajaxParams.data = this.filterData(ajaxParams.data);
      /* eslint no-undef: "off" */

      if (window.ga !== undefined) {
        try {
          ga('send', 'event', 'form', 'submit', this.action);
        } catch (e) {
          console.error(e);
        }
      }

      if (processedFormData.has('email')) {
        try {
          var brazeId = sha256(processedFormData.get('email').toString());
          Cookies.set('braze_id', brazeId, {
            expires: 356,
            path: '/'
          });
          braze === null || braze === void 0 ? void 0 : braze.changeUser(brazeId);
          var brazeUser = braze === null || braze === void 0 ? void 0 : braze.getUser();

          if (brazeUser) {
            brazeUser.setEmail(processedFormData.get('email').toString());

            if (processedFormData.has('first-name')) {
              brazeUser.setFirstName(processedFormData.get('first-name').toString());
            }

            if (processedFormData.has('last-name')) {
              brazeUser.setLastName(processedFormData.get('last-name').toString());
            }

            if (processedFormData.has('phone')) {
              brazeUser.setPhoneNumber(processedFormData.get('phone').toString());
            }

            brazeUser.setCustomUserAttribute('events', [this.action], true);

            if (this.action === 'vip-tables') {
              brazeUser.setCustomUserAttribute('vip-tables', [this.action], true);
            }

            brazeUser.setEmailNotificationSubscriptionType('opted_in');
          } else {
            braze === null || braze === void 0 ? void 0 : braze.logCustomEvent('formSubmittedByGuest', {
              name: this.action
            });
          }
        } catch (e) {
          console.error(e);
        }
      }

      return axios(ajaxParams).then(function (response) {
        return [response.data, response.status];
      }).then(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            response = _ref7[0],
            status = _ref7[1];

        if (_this3.checkResponse(response, status)) {
          if (_this3.$element.dataset.formNoReset === undefined) {
            var inputs = _this3.$element.querySelectorAll('input[type=file],input[type=text],input[type=tel],input[type=number],input[type=email],textarea');

            var checkboxes = _this3.$element.querySelectorAll('input[type=checkbox]');

            each(inputs, function (input) {
              input.classList.remove('has-error');
              input.value = '';
              emitEvent(input, 'change');
            });
            each(checkboxes, function (checkbox) {
              checkbox.classList.remove('has-error');
              checkbox.checked = false;
              emitEvent(checkbox, 'change');
            });
          }

          _this3.successStep();

          _this3.showSuccessMsg();

          emitEvent(_this3.$element, 'success', response);
        }
      })["catch"](function (e) {
        _this3.showErrorMsg();

        Object.keys(_this3.getErrorsFromResponse(e.response)).forEach(function (name) {
          var inputs = _this3.$element.querySelectorAll("input[name=\"".concat(name, "\"],input[name^=\"").concat(name, "[\"],textarea[name=\"").concat(name, "\"]"));

          var select = _this3.$element.querySelectorAll("select[name=\"".concat(name, "\"]"));

          var radio = _this3.$element.querySelectorAll("input[type=radio][name=\"".concat(name, "\"]"));

          var errorMessage = _this3.getErrorsFromResponse(e.response)[name];

          each(inputs, function (input) {
            var mess = _this3.getErrorsFromResponse(e.response)[name];

            var errorElement = input.parentElement.querySelector('.base-form__error');
            if (!errorElement || !mess) return;
            input.classList.add('has-error');
            errorElement.innerText = mess;
            emitEvent(input, 'error');
          });
          each(radio, function (customRadio) {
            if (!customRadio) return;
            var radioParent = customRadio.closest('.custom-radio');

            if (radioParent) {
              var errorElement = radioParent.querySelector('.base-form__error');
              radioParent.classList.add('has-error');

              if (errorElement) {
                errorElement.innerText = errorMessage;
              }
            }

            emitEvent(customRadio, 'error');
          });
          each(select, function (customSelect) {
            if (!customSelect) return;
            var selectParent = customSelect.closest('.custom-select');

            if (selectParent) {
              var errorElement = selectParent.nextElementSibling.querySelector('.base-form__error');
              selectParent.classList.add('has-error');

              if (errorElement) {
                errorElement.innerText = errorMessage;
              }
            }

            emitEvent(customSelect, 'error');
          }); // FIXME: this condition is not working every time

          if (_this3.getErrorsFromResponse(e.response)['g-recaptcha-response']) {
            var ReCaptcha = _this3.$element.querySelector('.recaptcha');

            var errorElement = ReCaptcha.querySelector('span.base-form__error');
            if (!errorElement || !ReCaptcha) return;
            ReCaptcha.classList.add('has-error');
            errorElement.innerText = _this3.getErrorsFromResponse(e.response)['g-recaptcha-response'];
          }
        });
        emitEvent(_this3.$element, 'error');

        _this3.errorStep();
      });
    }
  }, {
    key: "enableLoading",
    value: function enableLoading() {
      this.$element.classList.add('loading');
    }
  }, {
    key: "disableLoading",
    value: function disableLoading() {
      this.$element.classList.remove('loading');
    }
  }, {
    key: "initSteps",
    value: function initSteps() {
      if (this.$element.querySelectorAll('.form-part').length) {
        this.$steps = this.$element.querySelectorAll('.form-part:not(.success)');
        this.$defaultStep = this.$element.querySelectorAll('.form-part.default');
        this.$successStep = this.$element.querySelectorAll('.form-part.success');
        this.buttonPrev = this.$element.querySelector('[data-form-previous]');
        this.buttonNext = this.$element.querySelector('[data-form-next]');
        this.buttonSubmit = this.$element.querySelector('[data-form-submit]');
        this.stepsCount = this.$steps.length;
        this.stepsEnabled = true;
      } else {
        this.stepsEnabled = false;
      }

      this.hideButtons();
      this.animateStepsLabels();
    }
  }, {
    key: "animateStepsLabels",
    value: function animateStepsLabels(currentStep, prevStep) {
      if (!this.stepsEnabled) {
        return;
      }

      each(this.stepsLabels, function (label) {
        if (label.classList.contains('is-active')) {
          label.classList.remove('is-active');
        }
      });

      if (this.currentStep === 0) {
        each(this.stepsLabels, function (label) {
          if (label.classList.contains('is-completed')) {
            label.classList.remove('is-completed');
          }
        });
      }

      this.stepsLabels[this.currentStep].classList.add('is-active');

      if (currentStep > prevStep) {
        this.stepsLabels[prevStep].classList.add('is-completed');
      } else if (currentStep < prevStep) {
        this.stepsLabels[currentStep].classList.remove('is-completed');
      }
    }
  }, {
    key: "hideButtons",
    value: function hideButtons() {
      if (this.stepsEnabled) {
        each([this.buttonPrev, this.buttonNext], function (button) {
          button.classList.remove('visually-hidden');
        });
        this.buttonSubmit.classList.add('visually-hidden');

        if (this.isFirstStep()) {
          this.buttonPrev.classList.add('visually-hidden');
        } else if (this.isLastStep()) {
          this.buttonNext.classList.add('visually-hidden');
          this.buttonSubmit.classList.remove('visually-hidden');
        }
      }
    }
  }, {
    key: "hideVisibleSteps",
    value: function hideVisibleSteps() {
      var visibleSteps = filter(this.$steps, '.is-visible');
      each(visibleSteps, function (step) {
        step.classList.remove('is-visible');
      });
    }
  }, {
    key: "defaultStep",
    value: function defaultStep() {
      var _this4 = this;

      if (this.stepsEnabled) {
        this.hideVisibleSteps();
        each(this.$successStep, function (step) {
          step.classList.remove('is-visible');
        });
        each(this.$defaultStep, function (step) {
          step.classList.add('is-visible');
        });
        setTimeout(function () {
          var firstInput = _this4.$defaultStep.querySelector('input');

          emitEvent(firstInput, 'focus');
        }, 100);
      }
    }
  }, {
    key: "successStep",
    value: function successStep() {
      if (this.stepsEnabled) {
        this.hideVisibleSteps();
        each(this.$successStep, function (step) {
          step.classList.add('is-visible');
        });
        this.addSuccessStepClass();
      }
    }
  }, {
    key: "errorStep",
    value: function errorStep() {
      if (this.stepsEnabled) {
        var errorStepIndex = Array.from(this.$steps).findIndex(function (step) {
          return !!step.querySelector('.has-error');
        });
        var step = this.$steps[errorStepIndex];
        this.stepsLabels.forEach(function (stepLabel, i) {
          if (i >= errorStepIndex) {
            stepLabel.classList.remove('is-completed');
          }
        });

        if (!is(this.$steps.item(this.currentStep), step)) {
          var _step$querySelector;

          this.currentStep = errorStepIndex;
          this.hideButtons();
          this.hideVisibleSteps();
          step.classList.add('is-visible');
          (_step$querySelector = step.querySelector('input.has-error')) === null || _step$querySelector === void 0 ? void 0 : _step$querySelector.focus();
        }
      }
    }
  }, {
    key: "resetFormSteps",
    value: function resetFormSteps(e) {
      if (e.detail === this.action && this.isSuccessStep) {
        this.currentStep = 0;
        this.hideButtons();
        this.animateStepsLabels();
        this.resetForm();
        this.$successStep[0].classList.remove('is-visible');
        this.$defaultStep[0].classList.add('is-visible');
        document.querySelector('.new-account-popup__content').classList.remove('is-success-step-visible');
      }
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      this.$element.reset();
    }
  }, {
    key: "isLastStep",
    value: function isLastStep() {
      if (this.stepsEnabled) {
        return this.currentStep + 1 >= this.stepsCount;
      }

      return true;
    }
  }, {
    key: "isFirstStep",
    value: function isFirstStep() {
      if (this.stepsEnabled) {
        return this.currentStep - 1 < 0;
      }

      return true;
    }
  }, {
    key: "isSuccessStep",
    value: function isSuccessStep() {
      if (this.stepsEnabled) {
        return this.$successStep[0].classList.contains('is-visible');
      }

      return false;
    }
  }, {
    key: "nextStep",
    value: function nextStep() {
      if (this.stepsEnabled && !this.isLastStep()) {
        var _currentStep$classLis, _currentStep$classLis2, _currentStep$querySel;

        this.currentStep++;
        this.hideVisibleSteps();
        this.hideButtons();
        var currentStep = this.$steps.item(this.currentStep);
        /* eslint no-unused-expressions: "off" */

        currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$classLis = currentStep.classList) === null || _currentStep$classLis === void 0 ? void 0 : (_currentStep$classLis2 = _currentStep$classLis.add) === null || _currentStep$classLis2 === void 0 ? void 0 : _currentStep$classLis2.call(_currentStep$classLis, 'is-visible');
        emitEvent(currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$querySel = currentStep.querySelector) === null || _currentStep$querySel === void 0 ? void 0 : _currentStep$querySel.call(currentStep, 'input'), 'focus');
      }
    }
  }, {
    key: "previousStep",
    value: function previousStep() {
      if (this.stepsEnabled && !this.isFirstStep()) {
        var _currentStep$classLis3, _currentStep$classLis4, _currentStep$querySel2;

        this.currentStep--;
        this.hideVisibleSteps();
        this.hideButtons();
        var currentStep = this.$steps.item(this.currentStep);
        /* eslint no-unused-expressions: "off" */

        currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$classLis3 = currentStep.classList) === null || _currentStep$classLis3 === void 0 ? void 0 : (_currentStep$classLis4 = _currentStep$classLis3.add) === null || _currentStep$classLis4 === void 0 ? void 0 : _currentStep$classLis4.call(_currentStep$classLis3, 'is-visible');
        emitEvent(currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$querySel2 = currentStep.querySelector) === null || _currentStep$querySel2 === void 0 ? void 0 : _currentStep$querySel2.call(currentStep, 'input'), 'focus');
      }
    } // new-account-popup

  }, {
    key: "addSuccessStepClass",
    value: function addSuccessStepClass() {
      if (this.isSuccessStep()) {
        document.querySelector('.new-account-popup__content').classList.add('is-success-step-visible');
      }
    }
  }, {
    key: "isMultiPart",
    get: function get() {
      return this.$element.getAttribute('enctype') === 'multipart/form-data';
    }
  }, {
    key: "action",
    get: function get() {
      return this.$element.dataset.formBase;
    }
  }]);

  return _class3;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class3.prototype, "ajaxMessage", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class3.prototype, "stepsLabels", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, "currentStep", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class3.prototype, "inputBlurHandler", [_dec5], Object.getOwnPropertyDescriptor(_class3.prototype, "inputBlurHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "customCheckboxClickHandler", [_dec6], Object.getOwnPropertyDescriptor(_class3.prototype, "customCheckboxClickHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "nextStepHandler", [_dec7], Object.getOwnPropertyDescriptor(_class3.prototype, "nextStepHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "previousStepHandler", [_dec8], Object.getOwnPropertyDescriptor(_class3.prototype, "previousStepHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "phoneCodeHide", [_dec9], Object.getOwnPropertyDescriptor(_class3.prototype, "phoneCodeHide"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "phoneCodeCurrent", [_dec10], Object.getOwnPropertyDescriptor(_class3.prototype, "phoneCodeCurrent"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "phoneCodeChange", [_dec11], Object.getOwnPropertyDescriptor(_class3.prototype, "phoneCodeChange"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "openHandler", [_dec12], Object.getOwnPropertyDescriptor(_class3.prototype, "openHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "submitHandler", [_dec13], Object.getOwnPropertyDescriptor(_class3.prototype, "submitHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "animateStepsLabels", [_dec14], Object.getOwnPropertyDescriptor(_class3.prototype, "animateStepsLabels"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "resetFormSteps", [_dec15], Object.getOwnPropertyDescriptor(_class3.prototype, "resetFormSteps"), _class3.prototype)), _class3)) || _class2);

export { _class as default };